export const GRITTER_ALERT_PUSH = 'GRITTER_ALERT_PUSH';
export const GRITTER_ALERT_DISMISS = 'GRITTER_ALERT_DISMISS';
